import { ApplicationState } from '../hooks'

export type ApplicationStateInfo = {
  code: string
  label: string
  intent: string
  groupCode: string
}

export function isEnrichedState(state: unknown): state is ApplicationStateInfo {
  return typeof state === 'object' && state !== null && 'code' in state && 'label' in state
}

export function getStateCode(state: ApplicationState | ApplicationStateInfo | undefined): ApplicationState | undefined {
  if (!state) return undefined
  if (isEnrichedState(state)) return state.code as ApplicationState
  return state
}

